import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";

class AddUserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  initialState = {
    userName: "",
    fullName: "",
    email: "",
    password: "",
    passwordConfirmation: "",
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  addUser(e) {
    e.preventDefault();
    this.props.handleSubmit(this.state);
    this.setState(this.initialState);
  }

  render() {
    let { open, toggle } = this.props;
    let { fullName, userName, email, password, passwordConfirmation } =
      this.state;
    return (
      <>
        <Modal isOpen={open} fade={false} toggle={toggle}>
          <ModalHeader toggle={toggle}>Thêm người dùng</ModalHeader>
          <ModalBody>
            <div class="row">
              <div class="col-md-12">
                <Form onSubmit={(e) => this.addUser(e)}>
                  <FormGroup>
                    <Label>Tên đầy đủ</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      value={fullName}
                      name="fullName"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Tên đăng nhập</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      value={userName}
                      name="userName"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      value={email}
                      name="email"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Mật khẩu</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="password"
                      required
                      value={password}
                      name="password"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Nhập lại mật khẩu</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="password"
                      required
                      value={passwordConfirmation}
                      name="passwordConfirmation"
                    />
                  </FormGroup>
                  <Button className="mb-2 me-2" type="submit">
                    Thêm
                  </Button>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default AddUserModal;
